import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../../core/services/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-email-support',
  templateUrl: 'email-support.component.html',
  styleUrls: ['email-support.component.scss']
})
export class EmailSupportComponent implements OnInit {

  constructor(
    private sharedService: SharedService
  ) { }

  sidenavToggle = false;
  
  ngOnInit(): void {
    let token = localStorage.getItem('sidenav');
    if(token === 'true') {
      this.toggleNav(token);
    }
  }

  toggleNav(value: any) {
    if (value === 'true') {
      this.sidenavToggle = true;
    } else if (value === 'false') {
      this.sidenavToggle = false;
    }
  }

  emailSupportForm = new FormGroup({
    userName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.pattern("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")]),
    phoneNo: new FormControl('', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern('.*\\S.*[0-9_-]')]),
    subject: new FormControl(''),
    messageBody: new FormControl('', Validators.required)
  });

  sendSupportMessage() {
    this.sharedService.sendMessage(this.emailSupportForm.value).subscribe(
      (res: any) => {
        Swal.fire('', 'Message Sent Successfully', 'success');
        this.emailSupportForm.reset();
      },
      (err: any) => {
        Swal.fire('', err.error.message ? err.error.message : err.message, 'error');
      }
    );
  }

}